import { combineReducers } from 'redux'
import { createApiReducer } from 'reacticoon/reducer'
import { getDiscordLoginUrl, handleDiscordCallback } from './actions'

const discordLoginReducer = createApiReducer(getDiscordLoginUrl)
const discordCallbackReducer = createApiReducer(handleDiscordCallback)

const discordAuthReducer = combineReducers({
  login: discordLoginReducer,
  callback: discordCallbackReducer,
})

export default discordAuthReducer
